import React from 'react'

import { superagent } from '../superagent/superagent';
import singletons from '../singletons'

import { sharedData } from '../../../models/shared_data'

export class CurFormatComponent extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    let pr = parseInt(this.props.price)
    let print = ''
    if(pr % 100.0 == 0) {
      print = pr / 100
    } else {
      print = (pr / 100.0).toFixed(2)
    }
    let t = this.props.type
    const symbol = sharedData.currency_symbol
    if(!t) {
      return (
        <span className={this.props.className}>{print}  {symbol}</span>
      )
    } else if(t == 'strong') {
      return (
        <strong className={this.props.className}>{print}  {symbol}</strong>

      )
    }


  }
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/react/shared/cur_format/cur_format.component.jsx